var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightedMultiselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5089_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99897 0C7.21874 0 5.47849 0.527841 3.99828 1.51677C2.51807 2.50571 1.36439 3.91131 0.683121 5.55585C0.00185536 7.20038 -0.176395 9.00998 0.170911 10.7558C0.518218 12.5016 1.37548 14.1053 2.6343 15.364C3.89311 16.6226 5.49694 17.4798 7.24296 17.8271C8.98899 18.1743 10.7988 17.9961 12.4435 17.3149C14.0882 16.6337 15.494 15.4802 16.483 14.0001C17.4721 12.5201 18 10.78 18 9C18 6.61305 17.0517 4.32387 15.3637 2.63604C13.6756 0.948212 11.3862 0 8.99897 0ZM8.63105 12.2846C8.44296 12.4679 8.1904 12.5701 7.92772 12.5691H7.91349C7.6454 12.5653 7.38968 12.4557 7.20202 12.2642L4.09802 9.06301L5.26481 7.92683L7.94195 10.687L12.7799 5.99187L13.9121 7.15854L8.63105 12.2846Z",
    fill: "#56BFD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5089_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedMultiselect);
export default __webpack_public_path__ + "static/media/highlighted-multiselect.bedfde08bbebceec0162a9fde45f5a8d.svg";
export { ForwardRef as ReactComponent };